// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay-module--overlay--Hoe1z","overlay__close":"overlay-module--overlay__close--1Mwrr"};